import { IInteractiveModInput } from "@blings/blings-player";
import { ModsPanelCompProps } from "../../ModsPanel";
import { Input, Row, Space, Switch } from "antd";
import { LayerSelector } from "../../../LayerSelector";
import { InfoTooltip } from "../../../../BaseComps/InfoTooltip";
import { buildParagraphTextLayerOption } from "../../../../helpers/layerSelectorFilters";
import { sharedInputAllowClear } from "../../../antd-extensions/selectClearIcon";

export function AddInteractiveInputForm(
  props: ModsPanelCompProps<IInteractiveModInput>
) {
  const { change, json } = props;
  return (
    <Space direction={"vertical"} size={12} style={{ width: "100%" }}>
      <div>
        <span style={{ color: "#6E7079", lineHeight: "22px" }}>
          Select a layer that will become an input field:
          <InfoTooltip
            style={{ display: "inline-block" }}
            info={
              "Input fields can be created only from paragraph text layers in Adobe After Effects"
            }
          />
        </span>
        <div style={{ marginTop: "4px" }}>
          <LayerSelector
            isMulti={false}
            placeholder="Select layer that will become input field"
            assetLayerPairs={props.assetLayerPairs}
            selectedAssetId={change.assetId}
            selectedLayerName={change.layerName}
            selectedLayerUid={change.layerUid}
            onChange={props.onLayerChange}
            index={props.index}
            jsonVid={json}
            mapFilterLayerFunc={(
              p,
              layerName,
              assetId,
              layerUid,
              additionals
            ) => {
              const option = buildParagraphTextLayerOption({
                layerName,
                assetId,
                layerUid,
                additionals,
                json,
              });
              if (option) p.push(option);
              return p;
            }}
          />
        </div>
      </div>
      <div>
        <span style={{ color: "#6E7079", lineHeight: "22px" }}>
          Select a name for the input field:
          <InfoTooltip
            style={{ display: "inline-block" }}
            info={"In order to access to the input value, use: `inputs[name]`"}
          />
        </span>
        <Input
          style={{ marginTop: "4px" }}
          value={change.value}
          // The index of the mod, the property name, the value to update
          onChange={(e) => props.onChange(props.index, "value", e.target.value)}
          allowClear={sharedInputAllowClear}
        />
      </div>
      <div>
        <span style={{ color: "#6E7079", lineHeight: "22px" }}>
          Set the placeholder message:
          <InfoTooltip
            style={{ display: "inline-block" }}
            info={
              "This text will be shown in the input field and will disappear when the user starts typing"
            }
          />
        </span>
        <Input
          style={{ marginTop: "4px" }}
          value={change.placeholder}
          onChange={(e) =>
            props.onChange(props.index, "placeholder", e.target.value)
          }
          allowClear={sharedInputAllowClear}
        />
      </div>
      <Row align="middle">
        <span>Short answer</span>
        <Switch
          checked={change.isMultiline || false}
          onChange={(e) => props.onChange(props.index, "isMultiline", e)}
        />
        <span>Multiline</span>
      </Row>
    </Space>
  );
}
